import { useSelector } from 'react-redux';
import { selectClientCalculationSettings } from '@client/model/selectors';
import { useProjectionForPolicy } from './useProjectionForPolicy';

/**
 * True when the new projection-details view should be offered for a policy:
 * the client's `useClaimProjectionEngine` calculation setting is on AND the
 * engine produced a projection for this funding source (i.e. it maps to a
 * projection strategy — see `pickStrategy` in `calcFundingSourceDerivatives.ts`).
 */
export function useHasProjectionView(fundingSourceId: string | undefined): boolean {
  const settings = useSelector(selectClientCalculationSettings);
  const projection = useProjectionForPolicy(fundingSourceId);
  return !!settings?.useClaimProjectionEngine && !!projection;
}
